export enum TestGroupName {
  EXPERIMENT = 'EXPERIMENT',
  CONTROL = 'CONTROL'
}
